module.exports = __webpack_public_path__ + "media/images/groupRank__eval--correct@3x-88cca023a0084de998a851be5ab6964e.png";